var GC = require('../../src/js/client/GlobalContext.js');

exports.globalContext = GC.GlobalContext;

exports.initialGlobal = GC.initialGlobal;
